export default __webpack_public_path__ + "static/media/addtag.f6267fef.svg";